export default __webpack_public_path__ + "static/media/ico-desplegar-menu.f7a45769.svg";